var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDrivingTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.223 5C8.077 5.642 8 6.311 8 7H6.853l-1.258 3.621c.994-.193 1.989-.34 2.983-.444.257.685.596 1.328 1.003 1.92-1.526.116-3.054.348-4.582.692L5 17h14v-1.223c.702-.16 1.372-.4 2.001-.713L21 20c0 .51-.388.935-.884.993L20 21h-1c-.51 0-.935-.388-.993-.884L18 20v-1H6v1c0 .51-.388.935-.884.993L5 21H4c-.51 0-.935-.388-.993-.884L3 20v-8l2.08-5.99c.195-.548.683-.95 1.28-1.004L6.5 5h1.723zM7.5 13c.83 0 1.5.67 1.5 1.5S8.33 16 7.5 16 6 15.33 6 14.5 6.67 13 7.5 13zM17 0c3.86 0 7 3.14 7 7 0 3.861-3.14 7-7 7-3.859 0-7-3.139-7-7 0-3.86 3.141-7 7-7zm0 2c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm1 1v3h2v2h-4V3h2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrivingTime);
export default __webpack_public_path__ + "static/media/icon-driving-time.69242c99e96ab28b9dd10182b254dbe1.svg";
export { ForwardRef as ReactComponent };